import BinaryFilter from '@/lib/dx/filter/binary-filter';
import ComplexFilter from '@/lib/dx/filter/complex-filter';

function transformFilter(filter) {
  // binary filter: ['foo', '>', 3]
  if (filter.length === 3 && filter.every(el => !el || typeof el !== 'object')) {
    const [getter, operator, value] = filter;

    return new BinaryFilter(getter, operator, value);
  }

  // unary filter: ['!', ['bar', '=', 42]]
  if (filter.length === 2 && filter[0] === '!') {
    const [, negatedFilter] = filter;

    return transformFilter(negatedFilter)
      .negated();
  }

  // complex filter:
  // [
  //   ['foo', 'contains', 'something'],
  //   'and',
  //   ['bar', 'startswith', 'a new hope']
  // ]
  if (filter.length >= 2 && filter.some(el => el && typeof el === 'object')) {
    const conjunction = filter.includes('or') ? 'or' : 'and';

    const filters = filter
      .filter(el => typeof el === 'object')
      .map(transformFilter);

    return new ComplexFilter(conjunction, filters);
  }

  throw Error('cannot transform filter');
}

export default function filterToWhere(filter) {
  return transformFilter(filter).toWhere();
}
